import './toggle.scss';
import { Icon } from '@/comp/icon/icon';

const ToggleSwitch = ({
    checked,
    onChange,
    label,
    disabled = false,
}: {
    checked: boolean;
    onChange: (value: boolean) => void;
    label: string;
    disabled?: boolean;
}) => (
    <label className="toggle">
        <Icon name={checked ? 'toggle_on' : 'toggle_off'} size={30} className={`icon ${checked ? 'active' : ''}`} />
        <span className="toggle-label">{label}</span>

        <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
    </label>
);
export default ToggleSwitch;
